export default "__VITE_ASSET__7f6785e0__"